export default __webpack_public_path__ + "static/media/C7.fcc882a7.png";